import { TimeDimensionGranularity } from '@cubejs-client/core';

export default function periodically(granularity: TimeDimensionGranularity) {
  return granularity === 'day' ? 'daily' : (`${granularity}ly` as const);
}
